const path = require('path')

const router = require('../../router')


module.exports = async(graphql, actions, route) => {
  const { createPage } = actions
  const looksContainer = path.resolve('src/containers/Looks/index.js')

  return createPage({
    path: router(route.path),
    component: looksContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
